import React from 'react';
import { motion } from 'framer-motion';

// Semi-donut margin gauge with a target threshold marker.
export function MarginGauge({ marginPct, target = 15, basisLabel }) {
  const max = 40;
  const clamped = Math.min(Math.max(marginPct, 0), max);
  const pct = clamped / max;
  const targetPct = Math.min(target / max, 1);
  const below = marginPct < target;
  const color = below ? 'hsl(var(--danger))' : 'hsl(var(--success))';

  const R = 52, CX = 64, CY = 64;
  const arc = (p) => {
    const a = Math.PI * (1 - p); // from 180deg to 0
    return { x: CX + R * Math.cos(a), y: CY - R * Math.sin(a) };
  };
  const start = arc(0), end = arc(pct);
  const big = pct > 0.5 ? 1 : 0;
  const fullEnd = arc(1);

  return (
    <div className="flex flex-col items-center" data-testid="margin-gauge">
      <svg width="128" height="78" viewBox="0 0 128 78">
        <path d={`M ${start.x} ${start.y} A ${R} ${R} 0 1 1 ${fullEnd.x} ${fullEnd.y}`} fill="none" stroke="hsl(var(--muted))" strokeWidth="10" strokeLinecap="round" />
        <motion.path d={`M ${start.x} ${start.y} A ${R} ${R} 0 ${big} 1 ${end.x} ${end.y}`} fill="none" stroke={color} strokeWidth="10" strokeLinecap="round"
          initial={false} animate={{ d: `M ${start.x} ${start.y} A ${R} ${R} 0 ${big} 1 ${end.x} ${end.y}` }} transition={{ duration: 0.5 }} />
        {/* target tick */}
        <line x1={CX + (R - 8) * Math.cos(Math.PI * (1 - targetPct))} y1={CY - (R - 8) * Math.sin(Math.PI * (1 - targetPct))}
          x2={CX + (R + 8) * Math.cos(Math.PI * (1 - targetPct))} y2={CY - (R + 8) * Math.sin(Math.PI * (1 - targetPct))}
          stroke="hsl(var(--foreground))" strokeWidth="2" />
      </svg>
      <div className="-mt-4 text-center">
        <div className="money text-2xl font-bold" style={{ color }}>{marginPct}%</div>
        <div className="text-[10px] text-muted-foreground">margin · target {target}%</div>
        {basisLabel && <div className="mt-0.5 text-[10px] text-muted-foreground/80">basis: {basisLabel}</div>}
      </div>
    </div>
  );
}
